import { api } from '@/services';
import { QueryFilters } from '@/types/services';
import { pathWithQuery } from '@/utils/string';
import { AnnotationHistory } from '@/entities/annotation-history/types';

export const getAnnotationsHistories = (
  filters: QueryFilters<AnnotationHistory>
): Promise<AnnotationHistory[]> => api.get(pathWithQuery('/annotation_histories', filters));
